import React, { Component } from "react";

export default class Card extends Component {
  render() {
    return (
      <div>
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12 card-name">{this.props.name}</div>
              <div className="col-5 card-img">
                <img className="img-fluid" src={this.props.img} alt="Sample" />
              </div>
              <div className="col-7 align-self-center">
                <p className="card-text">{this.props.text}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
